define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaLandownerTypeDomain = void 0;
    class WaLandownerTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaLandownerTypeDomain.PersonOrPrivateIndividual, value: "Person or Private Individual" },
                    { key: WaLandownerTypeDomain.SoleDirectorCompany, value: "Sole Director Company" },
                    { key: WaLandownerTypeDomain.OtherCompanyAgreementToBeSignedByTwoDirectors, value: "Other Company - agreement to be signed by two directors" },
                    { key: WaLandownerTypeDomain.OtherCompanyAgreementToBeSignedByADirectorAndTheSecretary, value: "Other Company - agreement to be signed by a director and the secretary" },
                    { key: WaLandownerTypeDomain.Trustee, value: "Trustee" },
                    { key: WaLandownerTypeDomain.PartnershipWithThreePartnersOrLess, value: "Partnership with three partners or less" },
                    { key: WaLandownerTypeDomain.PartnershipWithMoreThanThreePartners, value: "Partnership with more than three partners" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaLandownerTypeDomain.PersonOrPrivateIndividual] = 0;
                this.KeyIndex[WaLandownerTypeDomain.SoleDirectorCompany] = 1;
                this.KeyIndex[WaLandownerTypeDomain.OtherCompanyAgreementToBeSignedByTwoDirectors] = 2;
                this.KeyIndex[WaLandownerTypeDomain.OtherCompanyAgreementToBeSignedByADirectorAndTheSecretary] = 3;
                this.KeyIndex[WaLandownerTypeDomain.Trustee] = 4;
                this.KeyIndex[WaLandownerTypeDomain.PartnershipWithThreePartnersOrLess] = 5;
                this.KeyIndex[WaLandownerTypeDomain.PartnershipWithMoreThanThreePartners] = 6;
                this.ValueIndex = {};
                this.ValueIndex["Person or Private Individual"] = 0;
                this.ValueIndex["Sole Director Company"] = 1;
                this.ValueIndex["Other Company - agreement to be signed by two directors"] = 2;
                this.ValueIndex["Other Company - agreement to be signed by a director and the secretary"] = 3;
                this.ValueIndex["Trustee"] = 4;
                this.ValueIndex["Partnership with three partners or less"] = 5;
                this.ValueIndex["Partnership with more than three partners"] = 6;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaLandownerTypeDomain = WaLandownerTypeDomain;
    Object.defineProperty(WaLandownerTypeDomain, "PersonOrPrivateIndividual", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaLandownerTypeDomain, "SoleDirectorCompany", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaLandownerTypeDomain, "OtherCompanyAgreementToBeSignedByTwoDirectors", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(WaLandownerTypeDomain, "OtherCompanyAgreementToBeSignedByADirectorAndTheSecretary", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(WaLandownerTypeDomain, "Trustee", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(WaLandownerTypeDomain, "PartnershipWithThreePartnersOrLess", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(WaLandownerTypeDomain, "PartnershipWithMoreThanThreePartners", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(WaLandownerTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
